export const SET_CLASS_TRIB_IBS_CBS_COLLECTION = 'IBS_REGIME/SET_CLASS_TRIB_IBS_CBS_COLLECTION';
export const SET_CST_IBS_CBS_COLLECTION = 'IBS_REGIME/SET_CST_IBS_CBS_COLLECTION';
export const SET_CLASS_TRIB_IS_COLLECTION = 'IBS_REGIME/SET_CLASS_TRIB_IS_COLLECTION';
export const SET_CST_IS_COLLECTION = 'IBS_REGIME/SET_CST_IS_COLLECTION';
export const SET_COD_CRED_PRES_COLLECTION = 'IBS_REGIME/SET_COD_CRED_PRES_COLLECTION';
